const composeClassName = (
  ...classes: (string | undefined | null | boolean)[]
) => {
  return classes.filter(Boolean).join(' ');
};

export { composeClassName };
